import type { AxiosResponse } from 'axios'
import { apiClient } from '../client'
import { API_ENDPOINTS } from '@/config/api'
import { handleApiError } from '@/utils/apiErrorHandling'
import type {
  PatientEntityLookupData,
  PatientEntityLookupResponse,
} from '@/types/api/patients'

class PatientEntityService {
  private fallbackData(): PatientEntityLookupData {
    return {
      patients: [],
      patient: null,
      count: 0,
    }
  }

  async lookupByContactNumber(
    contactNumber: string
  ): Promise<PatientEntityLookupData> {
    try {
      const response: AxiosResponse<PatientEntityLookupResponse> =
        await apiClient.get(API_ENDPOINTS.ENTITIES, {
          params: {
            entity: 'patients',
            contact_number: contactNumber,
          },
        })

      return response.data.data || this.fallbackData()
    } catch (error) {
      throw handleApiError(error, 'lookupPatientEntityByContactNumber')
    }
  }

  async lookupByContactNumbers(
    contactNumbers: string[]
  ): Promise<PatientEntityLookupData> {
    if (contactNumbers.length === 0) return this.fallbackData()

    try {
      const response: AxiosResponse<PatientEntityLookupResponse> =
        await apiClient.get(API_ENDPOINTS.ENTITIES, {
          params: {
            entity: 'patients',
            contact_numbers: contactNumbers.slice(0, 10).join(','),
          },
        })

      return response.data.data || this.fallbackData()
    } catch (error) {
      throw handleApiError(error, 'lookupPatientEntitiesByContactNumbers')
    }
  }
}

export const patientEntityService = new PatientEntityService()
